import { render, staticRenderFns } from "./FooterToolbar.vue?vue&type=template&id=f0c28bee"
import script from "./FooterToolbar.vue?vue&type=script&lang=js"
export * from "./FooterToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports